export class MarketplaceCase {
  public OfferID: string;
  public VendorID: string;
  public Email: string;
  public Name: string;
  public Phone: string;
  public Title: string;
  public MyJSSIUserName: string;
  public Comments: string;
  public CompanyName: string;
}



// WEBPACK FOOTER //
// ./src/app/models/MarketplaceCase.ts